import styled from 'styled-components';

const HrLine = styled.hr`
  background: #ffa500;
  height: 3px;
  width: 60px;
  border: 0;
  margin: 0.7rem auto 2rem;
`;

export default HrLine;
